// src/theme/index.ts
import { techBlueTheme } from './techTheme';
import { lightTheme } from './lightTheme'; // 假设你已定义默认主题
import { darkblueTheme } from './darkblueTheme';
import { comicTheme } from './comicTheme';
import { macOSTheme } from './macosTheme';
import { ubuntuTheme } from './ubuntuTheme';
import { win31Theme } from './win31Theme';
import { xpTheme } from './xpTheme';
export const themeMap = {
  techBlue: techBlueTheme,
  lightWhite: lightTheme,
  darkBlue:darkblueTheme,
  comicColor:comicTheme,
  macOS:macOSTheme,
  ubuntu:ubuntuTheme,
  win31:win31Theme,
  xp:xpTheme,
};

export type ThemeName = keyof typeof themeMap;